export class Discussion {
    static toggleEditMode(btn) {
        const card = btn.closest('.card')
        const edit = card.querySelector('.edit-mode')
        card.querySelector('.view-mode').classList.toggle('is-hidden')
        const isVisible = ! edit.classList.toggle('is-hidden')
        btn.classList.toggle('is-active')
        if (isVisible) {
            edit.querySelector('textarea').focus()
        }
    }

    static toggleWatch(btn, discussion_id) {
        btn.disabled = true
        const navbar = btn.closest('.navbar')
        const lblNumWatchers = navbar.querySelector('.lbl-watchers')
        const wStart = navbar.querySelector('.btn-watch-start')
        const wStop = navbar.querySelector('.btn-watch-stop')
        axios.post(`/action/discussion/${discussion_id}/watch`).then((response) => {
            lblNumWatchers.innerText = response.data.watcher_count
            if (response.data.watched) {
                wStart.classList.add('is-hidden')
                wStop.classList.remove('is-hidden')
                wStop.disabled = false
            } else {
                wStart.classList.remove('is-hidden')
                wStop.classList.add('is-hidden')
                wStart.disabled = false
            }
        }).catch(error => {
            console.error(error)
            alert("Error watching post.")
        })
    }

    static vote(btn, post_id, direction) {
        axios.post(`/action/discussion_post/${post_id}/vote`, {"direction": direction}).then((response) => {
            const btn_up = btn.closest('.card').querySelector('.btn-upvote')
            const btn_down = btn.closest('.card').querySelector('.btn-downvote')
            if (response.data.my_upvote) {
                btn_up.classList.add('is-info')
            } else {
                btn_up.classList.remove('is-info')
            }
            if (response.data.my_downvote) {
                btn_down.classList.add('is-danger')
            } else {
                btn_down.classList.remove('is-danger')
            }
            btn_up.querySelector("span:nth-child(2)").innerText = response.data.upvotes
            btn_down.querySelector("span:nth-child(2)").innerText = response.data.downvotes
        }).catch(error => {
            console.error(error)
            alert("Error voting for post.")
        })
    }

    static deletePost(btn, post_id) {
        if (! confirm("Are you sure you want to delete this post?")) {
            return
        }
        axios.post(`/action/discussion_post/${post_id}/delete`, {}).then(response => {
            const card = btn.closest('.card')
            card.querySelector('.view-mode').innerHTML = "<i class='has-text-danger'>This post was deleted.</i>"
            card.querySelectorAll('.drop-on-delete').forEach(el => el.remove())
            card.querySelectorAll('.btn-upvote, .btn-downvote').forEach(el => el.disabled = true)
        }).catch(error => {
            console.error(error)
            alert("Error deleting post.")
        })
    }

    static toggleReply(btn) {
        const addComment = btn.closest('.card').querySelector('.add-comment')
        const isVisible = ! addComment.classList.toggle('is-hidden')
        btn.classList.toggle('is-active')
        if (isVisible) {
            addComment.querySelector('textarea').focus()
        }
    }

    static updatePost(form) {
        form.disabled = true
        axios.post(form.action, new FormData(form)).then(response => {
           // form.reset()
            form.querySelector('textarea').value = response.data.text
            form.disabled = false
            const card = form.closest('.card')
            this.toggleEditMode(card.querySelector('.btn-edit'))
            card.querySelector('div.view-mode').innerHTML = response.data.text.replaceAll("\n", "<br>")
            // card.querySelector('.date-time').innerHTML = `<i>edited</i>&nbsp;${response.data.last_edited}`
        }).catch(error => {
            console.error(error)
            alert("Error updating post.")
        })
    }

    static createPost(form, child_container=undefined) {
        form.disabled = true
        axios.post(form.action, new FormData(form)).then(response => {
            form.reset()
            form.disabled = false
            const container = form.closest('.comment-container')
            try {
                this.toggleReply(container.querySelector('.btn-reply'))
            } catch (e) {}
            const c_container = child_container ? child_container : container.querySelector('.children-container')
            c_container.insertAdjacentHTML('beforeend', response.data)
            c_container.lastElementChild.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }).catch(error => {
            console.error(error)
            alert("Error creating post.")
        })
    }
}